import { utils_copy } from "./Utils";

/**
 * @description This is the initialState of channelProducts reducer
 * @property {object} amazon_uae - All required product details and images fetched from amazon UAE.
 */
const initialState = {
  amazon_uae: {
    repr_image_url: "",
    repr_high_def_url: "",
    images: {
      all_images: [
        {
          pk: "",
          "main-url": "",
          "midimage-url": "",
          "thumbnail-url": "",
        },
      ],
      main_images: [
        {
          pk: "",
          "main-url": "",
          "midimage-url": "",
          "thumbnail-url": "",
          is_main_image: true,
        },
      ],
      sub_images: [
        {
          pk: "",
          "main-url": "",
          "midimage-url": "",
          "thumbnail-url": "",
          is_sub_image: true,
          sub_image_index: "",
        },
      ],
    },
    product_id: "",
    material_type: "",
    channel_product_json: {
      product_name: "",
      product_description: "",
      product_attribute_list: [],
      category: "",
      sub_category: "",
      created_date: "",
      feed_product_type: "",
      ASIN: "",
      recommended_browse_nodes: "",
      update_delete: "",
      status: "",
      http_link: "",
      was_price: "",
      sale_price: "",
      stock: "",
    },
    status: "",
  },
};

/**
 * @description This is redux reducer for fetching product catalog from Amazon UAE
 * changes/updates state  for different cases like fetch channel product from amazon uae etc..
 * @typedef StateType - state type of channelProducts reducer, default state is initial state
 * @param {object} state
 * @param {object} action
 * @returns {StateType} returns updated state
 */
export default function channelProducts(state = initialState, action) {
  switch (action.type) {
    case "FETCH_CHANNEL_PRODUCT_AMAZON_UAE":
      let channel_product_json = utils_copy(
        state.amazon_uae.channel_product_json,
        action.payload.channel_product_json
      );
      action.payload.channel_product_json = channel_product_json;
      return { amazon_uae: { ...action.payload, ["status"]: "" } };
    case "SEND_FEED_BACK_TO_CHANNEL_FORM":
      return {
        amazon_uae: { ...state.amazon_uae, ["status"]: action.payload },
      };
    case "SET_IMAGE_AMAZON_UAE":
      return {
        amazon_uae: { ...state.amazon_uae, ["images"]: action.payload.images },
      };
    case "HANDEL_CHANGE_UAE":
      return { amazon_uae: { ...action.payload, ["status"]: "" } };
    default:
      return state;
  }
}
